import React, { PureComponent } from 'react';
import { ISession } from 'types';
// Components
import styles from './session-stats.scss';
import { round } from 'helpers/math';

interface SessionStatsProps {
  session: ISession;
  className: string;
}
export default class SessionStats extends PureComponent<SessionStatsProps> {
  render() {
    const { session, className } = this.props;
    if (className) cl += ' ' + className;

    const { speed_kts: speed = {}, gps = {}, bms_amp: amps = {}, duration } = session.stats || {};

    let min = 0;
    let sec = 0;
    if (duration) {
      const totalSec = duration.sum / 1000;
      sec = Math.round(totalSec) % 60;
      min = Math.floor(totalSec / 60) % 60;
    }

    return (
      <div className="row">
        <div className={styles.item}>
          <label>Avg speed</label>
          <div>{round(speed.avg || 0, 1)}kts</div>
        </div>
        <div className={styles.item}>
          <label>Distance</label>
          <div>{round(gps.sum || 0, 1)}km</div>
        </div>
        <div className={styles.item}>
          <label>Duration</label>
          <div>
            {min < 10 && 0}
            {min}:{sec < 10 && 0}
            {sec}
          </div>
        </div>
        <div className={styles.item}>
          <label>Max Amp</label>
          <div>{round(amps.max / 100, 0) || 0}A</div>
        </div>
      </div>
    );
  }
}
